import React from 'react';

/**
 * FeatureGate - Legacy component for tier-based feature gating
 *
 * DEPRECATED: With per-seat billing, all features are unlimited for paying users.
 * This component now simply renders children without any gating.
 * Kept for backwards compatibility - can be removed when all usages are cleaned up.
 */
interface FeatureGateProps {
  children: React.ReactNode;
  requiredTiers?: string[];  // No longer used
  featureName?: string;      // No longer used
  featureDescription?: string; // No longer used
  benefits?: string[];       // No longer used
}

export const FeatureGate: React.FC<FeatureGateProps> = ({ children }) => {
  // Always render children - no tier restrictions
  return <>{children}</>;
};
